import './style.css';

import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { PostHogProvider } from 'posthog-js/react';
import { StrictMode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app.js';
import { ErrorBoundary } from './components';
import { AppSettings } from './constants/app-settings';
import { dynamicActivate } from './locale/i18n.js';

function LocalizedApp() {
  const [languageLoaded, setLanguageLoaded] = useState(false);

  // Load translations
  useEffect(() => {
    if (languageLoaded) {
      return;
    }

    dynamicActivate().then(() => {
      setLanguageLoaded(true);
    });
  }, [languageLoaded]);

  // Wait for translations to load before rendering
  if (!languageLoaded) {
    return null;
  }

  return (
    <I18nProvider i18n={i18n}>
      <App />
    </I18nProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={AppSettings.postHog.apiKey}
      options={{
        api_host: AppSettings.postHog.host,

        // Essential SaaS settings (non-defaults)
        capture_exceptions: true,
        secure_cookie: AppSettings.env === 'production',
        cross_subdomain_cookie: true,

        // Session replay privacy (non-defaults)
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '[data-ph-mask]',
          blockSelector: '[data-ph-no-capture]',
        },

        // Custom initialization
        loaded: posthog => {
          posthog.register({
            app_version: AppSettings.version || 'unknown',
            environment: AppSettings.env,
          });
        },
      }}
    >
      <ErrorBoundary>
        <LocalizedApp />
      </ErrorBoundary>
    </PostHogProvider>
  </StrictMode>,
);
